export default {
  billingRules: (tenantID: string) => ["billingRules", tenantID] as const,
};
